export default __webpack_public_path__ + "locales/fr/DeleteProfileEverDialog.json?hash=105cccb4cdd03e7886574a727327558e";